export const PERMISSIONS = {
    VIEW: 'View',
    USE_MODELS: 'Use Models',
    UPLOAD_DATA: 'Upload Data',
    DOWNLOAD_DATA: 'Download Data',
    SHARE_MODELS: 'Share Models',
    SHARE_FOLDERS: 'Share Folders',
    MANAGE_MODELS: 'Manage Models',
    MANAGE_FOLDER: 'Manage Folder',
    MANAGE_GROUP: 'Manage Group',
    VIEW_COMMENT: 'View Comments',
    ADD_COMMENT: 'Add Comments',
    MODERATE_COMMENTS: 'Moderate Comments'
};

export const FOLDER_PERMISSION_LABELS: Record<string, string> = {
    [PERMISSIONS.VIEW]: 'View',
    [PERMISSIONS.USE_MODELS]: 'Use Models',
    [PERMISSIONS.UPLOAD_DATA]: 'Upload Data',
    [PERMISSIONS.DOWNLOAD_DATA]: 'Download 3D Models',
    [PERMISSIONS.SHARE_MODELS]: 'Secondary Models',
    [PERMISSIONS.SHARE_FOLDERS]: 'Share Folders',
    [PERMISSIONS.MANAGE_MODELS]: 'Manage Files',
    [PERMISSIONS.MANAGE_FOLDER]: 'Manage Folder',
    [PERMISSIONS.MANAGE_GROUP]: 'Manage Group',
    [PERMISSIONS.VIEW_COMMENT]: 'View Comments',
    [PERMISSIONS.ADD_COMMENT]: 'Add Comments',
    [PERMISSIONS.MODERATE_COMMENTS]: 'Moderate Comments'
};

// create a type from the PERMISSIONS values
export type PermissionValue = (typeof PERMISSIONS)[keyof typeof PERMISSIONS];

export const FOLDER_PERMISSION_ARRAY = Object.values(PERMISSIONS).filter((p) => p !== PERMISSIONS.MANAGE_GROUP);
